export const inputClassNames =
  'border-thin border-grey-200 hover:border-grey-600 focus:bg-grey-050 relative flex items-center justify-center gap-2 rounded-lg py-1 px-4 transition-all focus:ring focus:outline-none'
